webpackJsonp([4],{

/***/ 1913:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1957)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1933),
  /* template */
  __webpack_require__(1981),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ffbf835",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1933:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_helpers_LoteStatus__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_components_popup_viewer_PopupViewer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_components_popup_viewer_PopupViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__default_components_popup_viewer_PopupViewer__);





/* harmony default export */ __webpack_exports__["default"] = ({
  nome: 'resultado-geracao-lotes-leilao',
  props: {
    quantidadeDeGrvsSelecionadas: {
      type: Number,
      default: function _default() {
        return 0;
      },
      required: true
    },
    lotesNaoGerados: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    }
  },
  components: {
    PopupViewer: __WEBPACK_IMPORTED_MODULE_2__default_components_popup_viewer_PopupViewer___default.a,
    HistoricoLeiloesGrv: function HistoricoLeiloesGrv() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 144));
    }
  },
  data: function data() {
    return {
      isLoaded: false,
      showHistoricoLeiloes: false,
      grvSelecionadaParaVerificarHistoricoDeLeiloes: null
    };
  },

  computed: {
    total: function total() {
      return this.quantidadeDeGrvsSelecionadas;
    },
    quantidadeLotesGerados: function quantidadeLotesGerados() {
      if (!this.total && this.total < this.lotesNaoGerados.length) return 0;
      return this.total - this.lotesNaoGerados.length;
    },
    porcentagemEfetividade: function porcentagemEfetividade() {
      var valor = +(this.quantidadeLotesGerados / this.total * 100).toFixed(2);
      return {
        valor: valor,
        class: valor === 100 ? 'text-success' : 'text-danger'
      };
    },
    semResultado: function semResultado() {
      return this.total === 0 && this.quantidadeLotesGerados === 0 && !this.lotesNaoGerados.length;
    },
    Status: function Status() {
      return __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_helpers_LoteStatus__;
    }
  },
  filters: {
    formatarData: function formatarData(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY LTS');
    }
  },
  mounted: function mounted() {
    this.isLoaded = true;
  },

  methods: {
    openHistoricoLeiloesViewer: function openHistoricoLeiloesViewer(_ref) {
      var id = _ref.id;

      this.grvSelecionadaParaVerificarHistoricoDeLeiloes = id;
      this.showHistoricoLeiloes = true;
    },
    closeHistoricoLeiloesViewer: function closeHistoricoLeiloesViewer() {
      this.grvSelecionadaParaVerificarHistoricoDeLeiloes = null;
      this.showHistoricoLeiloes = false;
    }
  }
});

/***/ }),

/***/ 1946:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1903)(true);
// imports


// module
exports.push([module.i, ".resultado-estatísticas-geracao[data-v-5ffbf835]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.resultado-estatísticas-geracao span[data-v-5ffbf835]{font-weight:700}.resultado-success[data-v-5ffbf835]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/leiloes/components/ResultadoGeracaoLotesLeilao.vue"],"names":[],"mappings":"AACA,iDACE,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,mBAAoB,AACxB,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC,AACD,sDACE,eAAkB,CACnB,AACD,oCACE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC","file":"ResultadoGeracaoLotesLeilao.vue","sourcesContent":["\n.resultado-estatísticas-geracao[data-v-5ffbf835] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.resultado-estatísticas-geracao span[data-v-5ffbf835] {\n  font-weight: bold;\n}\n.resultado-success[data-v-5ffbf835] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1957:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1946);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1904)("90548680", content, true, {});

/***/ }),

/***/ 1981:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Resultado da geração de lotes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.semResultado) ? _c('div', {
    staticClass: "resultado-estatísticas-geracao m-b-lg"
  }, [_c('div', [_vm._v("Total de GRVs: "), _c('span', [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _c('div', [_vm._v("Lotes criados: "), _c('span', [_vm._v(_vm._s(_vm.quantidadeLotesGerados))])]), _vm._v(" "), _c('div', [_vm._v("Lotes não gerados: "), _c('span', [_vm._v(_vm._s(_vm.lotesNaoGerados.length))])]), _vm._v(" "), _c('div', [_vm._v("Efetividade: "), _c('span', {
    class: _vm.porcentagemEfetividade.class
  }, [_vm._v(_vm._s(_vm.porcentagemEfetividade.valor) + "%")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.semResultado) ? _c('div', {
    staticClass: "text-dark resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Leilão não foi gerado via preparação de leilão!")])]) : (_vm.porcentagemEfetividade.valor === 100) ? _c('div', {
    staticClass: "text-success resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Todos os lotes foram gerados com sucesso!")])]) : _c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-whit b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("GRV")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("DATA")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("MOTIVO")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Histórico de leilões")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.lotesNaoGerados), function(item) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item"
    }, [_c('td', [_vm._v(_vm._s(item.grv.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatarData")(item.data.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.motivo))]), _vm._v(" "), _c('td', [_c('ul', [_c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.openHistoricoLeiloesViewer(item.grv)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    }), _vm._v(" Histórico de leilões")])])])])
  }), 0)])])])])]), _vm._v(" "), (_vm.showHistoricoLeiloes) ? _c('popup-viewer', {
    on: {
      "close": _vm.closeHistoricoLeiloesViewer
    }
  }, [_c('HistoricoLeiloesGrv', {
    attrs: {
      "grvId": _vm.grvSelecionadaParaVerificarHistoricoDeLeiloes
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.c3332bd6216fc0c1809f.js